export default __webpack_public_path__ + "static/media/1585.1bbd1227.png";